import { NEXT_PUBLIC_IMAGE_CDN_URL } from '@pickleballinc/lib/constants';
import { getCDNURL } from '@pickleballinc/lib/get-cdn-url';
interface NoDataFoundProps {
	title: string;
	subtitle?: string;
}
export const NoDataFound = ({ title, subtitle }: NoDataFoundProps) => {
	return (
		<div className="mb-3 mt-1 flex w-full flex-col items-center justify-center px-3 sm:mt-0 sm:px-0">
			<img
				src={getCDNURL(`${NEXT_PUBLIC_IMAGE_CDN_URL}/global/empty-dataset/empty-dataset-alt-4.svg`, 320, 233)}
				width={320}
				height={233}
				alt={`${title}- Illustration`}
				className="mb-10"
			/>
			<h1 className="mb-3 text-xl font-semibold text-gray-900 sm:text-3xl">{title}</h1>
			{subtitle ? <h2 className="text-center font-medium text-gray-700">{subtitle}</h2> : null}
		</div>
	);
};
